export default "__VITE_ASSET__VanKlJah__"